import { GenericStateTwoBlockCombinedProps } from './types';

const usePresenter = (props: GenericStateTwoBlockCombinedProps): GenericStateTwoBlockCombinedProps => {
  return props;
};

export default usePresenter;
